(function ($) {
    // Get Window Width and Height
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();

    /* Document ready functions */
    $(document).ready(function () {
        $('.mMenu').on('click', function () {
            if ($('html, body').hasClass('navOpen')) {
                $('html, body').removeClass('navOpen');
            } else {
                $('html, body').addClass('navOpen');
            }
        });

        $('.sidebar h4').on('click', function () {
            if (windowWidth < 1024) {
                $(this).next().toggleClass('visible');
            } else {
                $(this).next().addClass('visible');
            }
        })
    });

    $(window).resize(function () {
        // Get Window Width and Height on resize
        windowWidth = $(window).outerWidth();
        windowHeight = $(window).height();
    });
})(jQuery);
